import { render, staticRenderFns } from "./ex-tab-list.vue?vue&type=template&id=0ec54389&scoped=true&"
import script from "./ex-tab-list.vue?vue&type=script&lang=js&"
export * from "./ex-tab-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-tab-list.vue?vue&type=style&index=0&id=0ec54389&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec54389",
  null
  
)

export default component.exports